import { cn } from "@/lib/utils";
import { usePageTitle } from "@/components/PageTitleContext";

/**
 * Standard in-shell page chrome matching the dashboard content area.
 */
export function PageShell({ children, className }) {
  return (
    <div className={cn("@container/main flex flex-1 flex-col gap-2", className)}>
      <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">{children}</div>
    </div>
  );
}

/**
 * Page chrome under SiteHeader. Renders title above description; pushes
 * string titles to context so SiteHeader can override the last breadcrumb.
 */
export function PageHeader({ title, description, actions, className }) {
  usePageTitle(typeof title === "string" ? title : undefined);

  if (!title && !description && !actions) {
    return null;
  }

  return (
    <div
      className={cn(
        "flex flex-col gap-3 px-4 sm:flex-row sm:items-start sm:justify-between lg:px-6",
        className,
      )}
    >
      <div className="min-w-0 space-y-1">
        {title ? (
          <h1 className="text-lg font-semibold tracking-tight">{title}</h1>
        ) : null}
        {description ? (
          <div className="text-sm text-muted-foreground">{description}</div>
        ) : null}
      </div>
      {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}

export function PageBody({ children, className }) {
  return <div className={cn("flex flex-col gap-4 px-4 lg:px-6", className)}>{children}</div>;
}
